module.exports = __webpack_public_path__ + "static/img/3.fc4f89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/3.png
// module id = 6F37
// module chunks = 0